import React, { FC, useEffect, useState } from 'react';
import Linkify from 'react-linkify';
import { useLanguage } from 'languages/languageContext';
import { useAppDispatch, useAppSelector } from 'store';
import { decrementPostCommentsCount } from 'store/reducers/news';
import { imagePath, timeAgo } from 'utilities';
import { clearCommentsLikes, likeCommentRequest, unlikeCommentRequest } from 'store/actions/likes';
import { deleteReply, getReplies } from 'store/reducers/commentsSlice';
import { ButtonBase } from '@material-ui/core';
import { ReactComponent as DeleteIcon } from 'assets/delete_button_blue.svg';
import CommentsLikeButton from '../CommentsLikeButton';
import { getConfig } from 'config/config';
import defaultImage from 'assets/default_avatar.png';
import linkDecorator from 'components/UI/linkDecorator';
import { AttachmentsGallery } from 'components/Shared/AttachmentsGallery';
import CommentsLikesModal from '../CommentLikesModal';
import { useStyles } from './styles';
import { Props, State } from './types';
import DefaultModal from 'components/Shared/DefaultModal';
import Button from 'components/UI/Button';

const { theme, config } = getConfig();

export const Reply: FC<Props> = ({
  reply,
  toProfileHandler,
  userId,
  post,
  postId,
  kreiseId,
  toReplyHandler,
  isAdmin,
}) => {
  const dispatch = useAppDispatch();
  const { post: postTrans, btn, key } = useLanguage();
  const replyOwner = userId === reply.commenter._id;
  const [currentLikes, setCurrentLikes] = useState<Array<any>>([]);
  // const [showModal, setShowModal] = useState(false);
  const classes = useStyles({});
  let likedPost = false;
  let image;
  const commenterName = `${reply.commenter.name} ${reply.commenter.lastname}`;
  if (reply.commenter) {
    image = imagePath(null, reply.commenter.photo);
  }

  console.log({});
  useEffect(() => {
    setCurrentLikes(reply.liked_users || []);
  }, []);

  if (userId && currentLikes) {
    likedPost = currentLikes.includes(userId);
  }

  const [showLikes, setShowLikes] = useState(false);

  const initialState: State = {
    pageNumber: 1,
    showModal: false,
    news: null,
    kreiseId: null,
    pageNumberToComeBack: 1,
  };
  // MODAL HANDLER
  const onOpenLikesModal = () => {
    setShowLikes(true);
    document.body.style.overflow = 'hidden';
  };
  const onCloseLikesModal = () => {
    setShowLikes(false);
    dispatch(clearCommentsLikes());
  };
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  // const { replies, comments } = useAppSelector((state) => state.comments);
  // REPLY HANDLERS

  const likeCommentHandler = () => {
    const commentId = reply._id;
    if (userId && !likedPost) {
      const updatedLikes = [...currentLikes];
      updatedLikes.push(userId);
      setCurrentLikes(updatedLikes);
      dispatch(likeCommentRequest(userId, commentId));
    } else if (userId && likedPost) {
      const updatedLikes = [...currentLikes];
      const likeIndex = updatedLikes.indexOf(userId);
      const filteredLikes = updatedLikes.filter((like, i) => i !== likeIndex);
      setCurrentLikes(filteredLikes);
      dispatch(unlikeCommentRequest(userId, commentId));
    }
  };

  const onDeleteReply = (replyId: string) => {
    dispatch(deleteReply({ postId, replyId, commentId: reply.commentedEntityId }))
      .unwrap()
      .then(() => {
        dispatch(decrementPostCommentsCount({ postId, repliesCount: 0 }));
      });
    setShowDeleteModal(false);
  };

  return (
    <React.Fragment>
      {currentLikes ? (
        <div className={classes.container}>
          {(replyOwner || isAdmin) && (
            <ButtonBase
              className={classes.deleteButton}
              style={{ background: theme.BACKGROUND_SECONDARY }}
              onClick={() => setShowDeleteModal(true)}
            >
              <DeleteIcon />
            </ButtonBase>
          )}
          <div className={classes.senderWrapper}>
            <div
              className={classes.imageWrapper}
              style={{ borderColor: theme.BACKGROUND_SECONDARY }}
              onClick={() => toProfileHandler(reply.commenter)}
            >
              <img src={image || defaultImage} alt=" " className={classes.image} />
            </div>
            <div className={classes.heading}>
              <span
                onClick={() => toProfileHandler(reply.commenter)}
                className={classes.name}
                style={{ color: theme.TEXT_PRIMARY }}
              >
                {commenterName}
              </span>
              <span className={classes.date} style={{ color: theme.TEXT_PRIMARY }}>
                {timeAgo(reply.createdAt)}
              </span>
            </div>
          </div>

          <Linkify componentDecorator={linkDecorator}>
            <div className={classes.commentWrapper}>
              <p className={classes.comment} style={{ color: theme.TEXT_PRIMARY }}>
                {reply.content}
              </p>
            </div>
          </Linkify>
          {/* @ts-ignore */}
          <AttachmentsGallery documents={reply.documents} videos={reply.videos} images={reply.images} />
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <CommentsLikeButton
              likedUsers={currentLikes}
              likedPost={likedPost}
              showLikesHandler={onOpenLikesModal}
              likeHandler={likeCommentHandler}
            />
            {/* <CommentReplyButton theme={theme} replyHandler={() => toReplyHandler(comment)} /> */}
          </div>
        </div>
      ) : null}
      {showLikes ? (
        <CommentsLikesModal
          onClose={onCloseLikesModal}
          modalTitle={`Likes (${reply.liked_users.length})`}
          comment={reply}
        />
      ) : null}
      <DefaultModal
        showModal={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        modalTitle={config.APP_FULL_NAME}
        message={post.deleteComment}
      >
        <Button label={btn.cancelBtn} background={theme.BUTTON_SECONDARY} onClick={() => setShowDeleteModal(false)} />
        <Button label="OK" onClick={() => onDeleteReply(reply._id)} />
      </DefaultModal>
    </React.Fragment>
  );
};
